import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.7714 18.8571V6.51425M11.7714 18.8571L10.5569 17.6425C9.87102 16.9567 8.94123 16.5714 7.97129 16.5714H4.91349C4.40854 16.5714 4 16.1621 4 15.6571V6.05711C4 5.55216 4.40934 5.14282 4.91429 5.14282H8.42802C9.39795 5.14282 10.3282 5.52813 11.014 6.21397L11.7714 6.97139L12.5288 6.21398C13.2147 5.52813 14.1449 5.14282 15.1148 5.14282H19.0857C19.5907 5.14282 20 5.55216 20 6.05711V15.6571C20 16.1621 19.5907 16.5714 19.0857 16.5714H15.572C14.602 16.5714 13.6718 16.9567 12.986 17.6425L11.7714 18.8571Z",
  stroke: "currentColor",
  "stroke-width": "1.6",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }